/**
 * @Author: ZLZ
 * @Date: 2025-11-05 18:18:00
 * @LastEditors: ZLZ
 * @LastEditTime: 2025-11-05 18:18:00
 * @Description: 2.0 内容 寻龙诀 路由模块
 * @FilePath: \qs\src\router\modules\xunLongJue.js
 */
import Layout from "@/Layout";
export default [
  {
    path: "/xunLongJue",
    component: Layout,
    name: "XunLongJue",
    redirect: "/xunLongJue/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/xunLongJue/index.vue"),
        meta: {
          title: "寻龙诀",
          keepAlive: false,
          showFooter: false,
          showHead: false,
          showLeft: false,
          showRight: false
        }
      },
      {
        path: "strategy",
        component: () => import("@/views/xunLongJue/myStrategy.vue"),
        meta: {
          title: "我的策略",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: true,
          rightIcon: '帮助',
          slefBack: true,
        }
      },
    ]
  },
];
